import { createApp } from 'vue'
import App from './JustTransitionCarbonCollege.vue'

createApp(App).mount('#app-just-transition-carbon-college')
